interface LicenseStatusBadgeProps {
  licenseNumber: string | null | undefined;
}

/**
 * Badge profil joueur — indique uniquement si un numéro de licence est renseigné.
 * BoulesConnect ne vérifie PAS la validité fédérale (référentiel FFPJP non fiable) :
 * aucune mention « à jour / valide / vérifiée ». Cf. plan FFPJP auto-déclaration §11.
 */
export default function LicenseStatusBadge({ licenseNumber }: LicenseStatusBadgeProps) {
  if (!licenseNumber) {
    return <span className='text-xs text-slate-400'>Aucune licence renseignée</span>;
  }

  return (
    <span className='inline-flex items-center gap-1.5 rounded-full bg-slate-50 px-2.5 py-1 text-xs font-semibold text-slate-700 ring-1 ring-inset ring-slate-200'>
      Licence renseignée
    </span>
  );
}
